import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { OperationType, ROUTE_PATH } from 'common/constants/sm-constants';
import { RouteEnvelope, WidgetModel } from 'common/models/utility-models/base-model';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { SidebarModel } from 'common/models/utility-models/sidebar-model';
import { AuthenticationService } from 'common/services/core-services/authentication.service';
import { BroadcastService } from 'common/services/core-services/broadcast.service';
import { TokenService } from 'common/services/core-services/get-token.service';
import { SystemService } from 'common/services/core-services/system.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  sidebarModel = new SidebarModel();
  active: boolean[] = [];
  activeIndex: number;
  activeDropdownIndex: number | null = null;
  subItemActiveIndex: number[] = [];
  dropdownStates: any[] = [];
  profile: any = {};
  currentRoute: string = '';
  currentPath: string = '';
  isLogo: boolean = false;
  tokenDetails: any;
  subscription: Subscription;
  isAlumniProfileUpdated = true;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private broadcastService: BroadcastService,
    private route: ActivatedRoute,
    private systemService: SystemService,
    private cdr: ChangeDetectorRef,
    private tokenService: TokenService
  ) {
    // Update current path on route change
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentPath = event.url;
      }
    });

    // Subscribe to broadcast messages for profile updates
    this.subscription = this.broadcastService.getMessage().subscribe((message) => {
      if (message.type === 'profile') {
        this.profile = message.message;
      }
    });
  }

  ngOnInit() {
    
    this.tokenDetails = this.tokenService.getDetailsFromToken(localStorage.getItem('token'));
    if (this.tokenDetails.tokenData.status === 3) {

      this.navigateToRoleBasedPage()
    }
    this.currentRoute = this.router.url;
   
  

    // Load active sidebar index from localStorage
    const savedActiveIndex = localStorage.getItem('activeSidebarIndex');
    if (savedActiveIndex !== null) {
      this.activeIndex = parseInt(savedActiveIndex, 10);
      this.active[this.activeIndex] = true;
    } else {
      this.active[0] = true;
    }

    // Listen for sidebarActiveIndex updates
    this.systemService.sidebarActiveIndex.subscribe((data) => {
      if (data !== null) {
        this.activeIndex = parseInt(data, 10);
        this.updateActiveSidebarState();
      }
    });


    if (this.currentRoute) {
      this.setActiveIndexFromRoute(this.currentRoute, ROUTE_PATH, this.sidebarModel.sidebarItems);
      // this.updateActiveIndex()
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentPath = event.url;
        // this.updateActiveIndex();
        this.setActiveIndexFromRoute(this.currentPath, ROUTE_PATH, this.sidebarModel.sidebarItems);
      }
    });
    this.systemService.initAlumniProfileUpdateStatus();
    const isEligibleStatus = this.tokenDetails.tokenData.status === 2 || this.tokenDetails.tokenData.status === 3;
    
    if(this.tokenDetails.tokenData.role === 2 && isEligibleStatus) 
    {
      this.systemService.isAlumniProfileUpdated$.subscribe(status => {                
        this.isAlumniProfileUpdated = status;
      });
    }
   
    
    this.cdr.detectChanges();
  
  }

  ngAfterViewInit(): void {
    this.profile = this.tokenDetails?.['tokenData'];
    const regex = /(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png|jpeg)/g;
    this.isLogo = regex.test(this.profile?.profile_pic_path);
  }

  toggleDropdown(index: number, event: Event) {
    event.stopPropagation(); // Prevent event from bubbling up
    this.activeDropdownIndex = this.activeDropdownIndex === index ? null : index;
  }

  navigateToRoleBasedPage() {
    const loginData = localStorage.getItem('loginData');
    if (loginData) {
      const userRole = JSON.parse(loginData).userType;
      if (userRole === 2) {
        this.navigateToModule('student_profile', OperationType.UPDATE, 1);
      } else {
        this.navigateToModule('applicants', OperationType.MULTIUTILITY, 1);
      }
    } else {
      this.navigateToModule('adminDashboard', OperationType.VIEW, 1);
    }
  }

  navigateToModule(
    urlPath: string,
    operationType: OperationType,
    index: number,
    isDropdownItem: boolean = false,
    subItemIndex: number | null = null
  ) {

    if (urlPath === 'ssphub') {
      // window.location.href = `${environment.ssphubUrl}/ssp-hub/`;
      const baseUrl = window.location.origin; // window.location.href = `${baseUrl}/ssphub`;
      window.location.href = `${baseUrl}/ssp-hub/`;
    } else {
      localStorage.setItem('urlPath', urlPath);
      localStorage.setItem('operationType', operationType);
      localStorage.setItem('navigationTriggered', 'true');
      this.manageSidebar(index, subItemIndex);

      const envelope = new RouteEnvelope();
      envelope.type = operationType;
      envelope.transferData = new GridParams();

      this.activeIndex = index;
      if (isDropdownItem && subItemIndex !== null) {
        this.subItemActiveIndex[index] = subItemIndex;
      } else {
        this.activeDropdownIndex = null;
      }

      this.systemService.navigateByUrl(ROUTE_PATH[urlPath], envelope);
      localStorage.setItem('activeSidebarIndex', index.toString());
    }
  }

  manageSidebar(index: number, subItemIndex: number | null) {
    this.unSelectAllModules();
    this.active[index] = true;

    if (subItemIndex !== null) {
      this.subItemActiveIndex[index] = subItemIndex;
    }
  }

  unSelectAllModules() {
    this.active = this.active.map(() => false);
  }

  showSocialWall() {
    window.location.href = `${environment.ssphubUrl}/ssp-hub/`;
  }

  logout() {
    this.systemService.logout();
  }

  updateActiveSidebarState() {
    this.active = this.active.map((_, i) => i === this.activeIndex);
  }

  // setActiveIndexFromRoute(currentRoute: string, routePaths: { [key: string]: string }, sidebarItems: any[]) {
  //   const normalizedPath = currentRoute.replace(/^\//, ''); 
  //   const matchingRoutePath = Object.entries(routePaths).find(([key, path]) => {
  //     const normalizedRoutePath = (path as string).replace(/^\//, ''); 
  //     return normalizedPath.startsWith(normalizedRoutePath);
  //   });

  //   if (matchingRoutePath) {
  //     for (let i = 0; i < sidebarItems.length; i++) {
  //       const item = sidebarItems[i];
  //       const routeKey = matchingRoutePath[0];
  //       if (routePaths[item.slug] && 
  //           routePaths[item.slug].replace(/^\//, '') === routePaths[routeKey].replace(/^\//, '')) {
  //         this.activeIndex = i;
  //         this.active.fill(false);
  //         this.active[i] = true;
  //         break;
  //       }
  //       if (routePaths[item.slug] && 
  //           routePaths[routeKey].replace(/^\//, '').startsWith(routePaths[item.slug].replace(/^\//, ''))) {
  //         this.activeIndex = i;
  //         this.active.fill(false);
  //         this.active[i] = true;
  //         break;
  //       }
  //     }
  //   }
  // }

  setActiveIndexFromRoute(currentRoute: string, routePaths: { [key: string]: string }, sidebarItems: any[]) {
    const normalizedCurrentPath = currentRoute.replace(/^\//, '');
    let exactMatch = false;
    for (let i = 0; i < sidebarItems.length; i++) {
      const item = sidebarItems[i];

      if (routePaths[item.slug]) {
        const normalizedItemPath = routePaths[item.slug].replace(/^\//, '');
        if (normalizedCurrentPath === normalizedItemPath) {
          this.activeIndex = i;
          this.active.fill(false);
          this.active[i] = true;
          exactMatch = true;
          break;
        }
      }

      if (item.isDropdown && item.dropdownItems) {
        for (let j = 0; j < item.dropdownItems.length; j++) {
          const subItem = item.dropdownItems[j];
          if (routePaths[subItem.slug]) {
            const normalizedSubItemPath = routePaths[subItem.slug].replace(/^\//, '');
            if (normalizedCurrentPath === normalizedSubItemPath) {
              this.activeIndex = i;
              this.active.fill(false);
              this.active[i] = true;
              this.activeDropdownIndex = i;
              this.subItemActiveIndex[i] = j;
              exactMatch = true;
              break;
            }
          }
        }
      }
    }

    if (!exactMatch) {
      let bestMatchLength = 0;
      let bestMatchIndex = -1;
      let bestMatchSubIndex = -1;

      for (let i = 0; i < sidebarItems.length; i++) {
        const item = sidebarItems[i];

        if (routePaths[item.slug]) {
          const normalizedItemPath = routePaths[item.slug].replace(/^\//, '');
          if (normalizedCurrentPath.startsWith(normalizedItemPath) &&
            normalizedItemPath.length > bestMatchLength) {
            bestMatchLength = normalizedItemPath.length;
            bestMatchIndex = i;
            bestMatchSubIndex = -1;
          }
        }

        if (item.isDropdown && item.dropdownItems) {
          for (let j = 0; j < item.dropdownItems.length; j++) {
            const subItem = item.dropdownItems[j];
            if (routePaths[subItem.slug]) {
              const normalizedSubItemPath = routePaths[subItem.slug].replace(/^\//, '');
              if (normalizedCurrentPath.startsWith(normalizedSubItemPath) &&
                normalizedSubItemPath.length > bestMatchLength) {
                bestMatchLength = normalizedSubItemPath.length;
                bestMatchIndex = i;
                bestMatchSubIndex = j;
              }
            }
          }
        }
      }

      if (bestMatchIndex !== -1) {
        this.activeIndex = bestMatchIndex;
        this.active.fill(false);
        this.active[bestMatchIndex] = true;

        if (bestMatchSubIndex !== -1) {
          this.activeDropdownIndex = bestMatchIndex;
          this.subItemActiveIndex[bestMatchIndex] = bestMatchSubIndex;
        }
      }
    }
  }

  screen(type: string): boolean {
    return type.toLowerCase() === this.profile?.role.toLowerCase();
  }
}
